import biboClient from './biboClient';

const client = biboClient.create();

export default {
  appCache: () => {
    return client.post('/admin/api/appCache');
  },

  getBrandsMarkets: () => {
    return client.get('/admin/api/brandsmarkets');
  },
  postBrandsMarkets: (formItems) => {
    return client.post('/admin/api/brandsmarkets', formItems);
  },
  deleteBrandsMarkets: (id) => {
    return client.delete('/admin/api/brandsmarkets/' + id);
  },

  getApplicationExceptionLogs: (searchParams) => {
    return client.get('/admin/api/applicationExceptionLogs', {params: searchParams});
  },

  getCubes: () => {
    return client.get('/api/datagrabber/');
  },

  getLevelConfigs: () => {
    return client.get('/admin/api/levelConfigs');
  },
  postLevelConfigs: (formItems) => {
    return client.post('/admin/api/levelconfigs', formItems);
  },
  putLevelConfigs: (formItems) => {
    return client.put('/admin/api/levelconfigs/' + formItems.id, formItems);
  },
  deleteLevelConfigs: (id) => {
    return client.delete('/admin/api/levelconfigs/' + id);
  },

  getMeasureConfigs: () => {
    return client.get('/admin/api/measureConfigs');
  },
  postMeasureConfigs: (formItems) => {
    return client.post('/admin/api/measureconfigs', formItems);
  },
  putMeasureConfigs: (formItems) => {
    return client.put('/admin/api/measureconfigs/' + formItems.id, formItems);
  },
  deleteMeasureConfigs: (id) => {
    return client.delete('/admin/api/measuregroupconfigs/' + id);
  },

  getMeasureGroupConfigs: () => {
    return client.get('/admin/api/measuregroupConfigs');
  },
  postMeasureGroupConfigs: (formItems) => {
    return client.post('/admin/api/measuregroupconfigs', formItems);
  },
  putMeasureGroupConfigs: (formItems) => {
    return client.put('/admin/api/measuregroupconfigs/' + formItems.id, formItems);
  },
  deleteMeasureGroupConfigs: (id) => {
    return client.delete('/admin/api/measuregroupconfigs/' + id);
  },
}